module.exports = __webpack_public_path__ + "img/expar_logo_new2_cb.e39b58d3.svg";